import { render } from "./FileManagerPreview.vue?vue&type=template&id=121fa011"
import script from "./FileManagerPreview.vue?vue&type=script&lang=js"
export * from "./FileManagerPreview.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__